import firebaseApp from 'src/firebase/firebaseApp'

export const currentCoachName = (): string => {
  const user = firebaseApp.auth().currentUser

  return user?.displayName || user?.email || 'Unknown'
}
